import {
  FETCH_COMPANY_LOADING,
  FETCH_COMPANY_DONE,
  FETCH_COMPANY_ERROR,

  UPDATE_COMPANY_LOADING,
  UPDATE_COMPANY_DONE,
  UPDATE_COMPANY_ERROR,

  FETCH_COUNTRIES_LOADING,
  FETCH_COUNTRIES_DONE,
  FETCH_COUNTRIES_ERROR,

  FETCH_CITY_BY_COUNTRIES_LOADING,
  FETCH_CITY_BY_COUNTRIES_DONE,
  FETCH_CITY_BY_COUNTRIES_ERROR

} from './actions'

export default {
  [FETCH_COMPANY_LOADING] (state) {
    state.isLoading = true
  },

  [FETCH_COMPANY_DONE] (state, company) {
    state.company = company
    state.isLoading = false
  },

  [FETCH_COMPANY_ERROR] (state, error) {
    state.error = error
    state.isLoading = false
  },

  [UPDATE_COMPANY_LOADING] (state) {
    state.isLoading = true
  },

  [UPDATE_COMPANY_DONE] (state, company) {
    state.company = company
    state.isLoading = false
  },

  [UPDATE_COMPANY_ERROR] (state, error) {
    state.error = error
    state.isLoading = false
  },

  [FETCH_COUNTRIES_LOADING] (state) {
    state.countriesIsLoading = true
  },
  [FETCH_COUNTRIES_DONE] (state, countries) {
    state.countries = countries
    state.countriesIsLoading = false
  },
  [FETCH_COUNTRIES_ERROR] (state, error) {
    state.error = error
    state.countriesIsLoading = false
  },

  [FETCH_CITY_BY_COUNTRIES_LOADING] (state) {
    state.isLoadingcityBycountries = true
  },
  [FETCH_CITY_BY_COUNTRIES_DONE] (state, items) {
    state.cityBycountries = items
    state.isLoadingcityBycountries = false
    state.isErrcityBycountries = null
  },
  [FETCH_CITY_BY_COUNTRIES_ERROR] (state, error) {
    state.isErrcityBycountries = error
    state.cityBycountries = null
    state.isLoadingcityBycountries = false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/settings/company/mutations.js